<template>
  <div :class="{'active': isActive }" class="accordion">
    <div class="accordion-header" @click="isActive=!isActive">
      <!-- <h2>
        <a v-if="player" href="#" class="btn-player" @click.stop="test">
          <svg width="32" height="32" class="static player-btn" viewBox="0 0 80 80">
            <circle class="circle-base" cx="40" cy="40" r="38" />
            <path class="play-btn" d="M31.93 52.033V27.967a3.059 3.059 0 0 1 4.844-2.482l16.723 12.032a3.059 3.059 0 0 1 0 4.966L36.774 54.515a3.059 3.059 0 0 1-4.845-2.482z" />
          </svg>
        </a>
        {{ title }}
      </h2> -->
      <slot name="header" />
      <a :id="anchor" :name="anchor">
        <i class="material-icons">
          expand_less
        </i>
      </a>
    </div>
    <div class="accordion-content">
      <slot name="content" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: {
      type: String,
      default: ''
    },
    anchor: {
      type: String,
      default: ''
    },
    active: {
      type: Boolean,
      default: false
    },
    player: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isActive: this.active ? this.active : false
    }
  },
  created() {
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.accordion{
  .accordion-header{
    position: relative;
    padding: 10px 36px;
    background: $grey-f3;
    cursor: pointer;
    h2{
      font-size: 16px;
      font-weight: bold;
      line-height: 1.6;
      color: $grey-9b;
      margin: 0;
      padding: 0;
    }
    i{
      display: inline-block;
      position: absolute;
      width: 24px;
      height: 24px;
      right: 16px;
      top: 0;
      bottom: 0;
      margin: auto;
      color: $grey-50;
      transform: rotate(-180deg);
      transform-origin: center;
      transition: all .3s ease-in-out;
    }
    .btn-player{
      display: inline-block;
      position: relative;
      width: 32px;
      height: 32px;
      // margin-right: 8px;
      vertical-align: middle;
      z-index: 1;
      cursor: pointer;
      .circle-base {
        fill: none;
        stroke: $grey-ec;
        stroke-width: 3px;
        fill: #fff;
      }
      .play-btn {
        fill: $grey-50;
        transition: all .3s;
      }
      &:hover{
        .play-btn {
          fill: $grey-9b;
        }
      }
    }
  }
  .accordion-content{
    max-height: 0;
    overflow: hidden;
    opacity: 0;
    // padding: 0 36px;
    border: 1px solid $grey-ec;
    border-top: 0;
    border-bottom: 0;
    transition-property: max-height, padding, opacity;
    transition-duration: .3s;
    transition-timing-function: ease-in-out;
  }
  &:first-child{
    .accordion-header{
      border-radius: 4px 4px 0 0;
    }
  }
  &:last-child{
    .accordion-header{
      border-radius: 0 0 4px 4px;
    }
    &.active{
      .accordion-header{
        border-radius: 0;
      }
      .accordion-content{
        border-radius: 0 0 4px 4px;
      }
    }
  }
  &.active{
    .accordion-header{
      i{
        transform: rotate(0deg);
        transition-timing-function: ease-in;
      }
    }
    .accordion-content{
      max-height: 5000px;
      opacity: 1;
      border: 1px solid $grey-ec;
      transition-timing-function: ease-out;
    }
  }
}

@media only screen and (max-width: 767.98px) {
  .accordion{
    .accordion-header{
      padding: 10px 8px;
      i{
        right: 8px;
      }
    }
  }
}

</style>
